import { ChangeDetectorRef, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { fadeInAnimation } from 'app/animations';
import * as fromRoot from '../../../../core/store';
import { ClientUsersLoadAction } from 'app/core/store/admin/users/users.actions';
import { ClientUser, ClientUsers } from 'app/core/store/admin/users/users.interface';
import { UserPageContainer } from '../../abstract-user/user-page-container/user-page.container';
import { goAction } from 'app/core/store/router/router.actions';
import { first, map, takeWhile } from 'rxjs/operators';
import { UsersSandbox } from '../../../../core/sandboxes/users.sandbox';
import { AdminDefinition } from '../../../../core/store/admin/admin-definitions/admin-definitions.interface';

@Component({
  selector: 'admin-client-user-page',
  templateUrl: './client-user-page.container.html',
  styleUrls: ['../../abstract-user/user-page-container/user-page.container.scss'],
  animations: [fadeInAnimation],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientUserPageContainer extends UserPageContainer {
  users: ClientUsers;
  sortField: string;
  sortAscending: boolean;
  isAgent: boolean = false;
  soldTos: AdminDefinition[];

  constructor(public usersSandbox: UsersSandbox) {
    super();
    this.store
      .select('admin')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((admin: { clientUsers: ClientUsers }) => admin && admin.clientUsers)
      )
      .subscribe(users => {
        this.users = users;
        this.pageNr = users.pageNr;
        this.sortField = users.sortField;
        this.sortAscending = users.sortAscending;
      });
    this.store.pipe(first()).subscribe(root => (this.isAgent = root.session.userContext.isAgent));
  }

  protected reload(): void {
    this.store.dispatch(
      new ClientUsersLoadAction({
        adminDefinitions: this.adminDefinitions,
        filter: this.filter,
        pageSize: this.pageSize,
        pageNr: this.pageNr,
        sortField: this.sortField,
        sortAscending: this.sortAscending,
      })
    );
  }

  inviteNewClientUser(): void {
    this.store.dispatch(goAction({ path: `/admin/clientUsers/invite` }));
  }

  createNewClientUser(): void {
    this.store.dispatch(goAction({ path: `/admin/clientUsers/create` }));
  }

  bulkInviteOrCreate(): void {
    this.store.dispatch(goAction({ path: `/admin/clientUsers/bulkInviteCreate` }));
  }

  openClientUser(clientUser: ClientUser): void {
    if (this.userContext.adminRoles.updateClientUser) {
      this.store.dispatch(goAction({ path: `/admin/clientUsers/${clientUser.id}/edit` }));
    } else {
      this.store.dispatch(goAction({ path: `/admin/clientUsers/${clientUser.id}` }));
    }
  }

  onPageChange(pageNr): void {
    this.pageNr = pageNr;
    this.reload();
  }

  sortChange({ sortField, sortAscending }) {
    this.sortField = sortField;
    this.sortAscending = sortAscending;
    this.reload();
  }

  downloadList() {
    this.usersSandbox.downloadClientUsers(this.filter);
  }

  async salesOrganisationSelected(salesOrganisationId: string): Promise<void> {
    this.soldTos = [];
    this.cd.markForCheck();
    this.soldTos = await this.usersSandbox.getSoldTos(salesOrganisationId);
    this.cd.markForCheck();
  }
}
